/* eslint-disable @typescript-eslint/no-explicit-any */
import api from '@/services/api';
import { UsageChart } from '@/types';

export const serviceUsageChart = async () => {
  try {
    const response = await api.get<UsageChart[]>('/usage/chart');
    return response.data;
  } catch (error: any) {
    const messageError = error?.response?.data?.message || error?.message;
    console.log('messageError', messageError);
    if (messageError) {
      throw new Error(messageError);
    }
    throw new Error('Erro interno do servidor');
  }
};
